import { Injectable } from '@angular/core';
import { SideNavOpn } from '@env/environment';

@Injectable({
  providedIn: 'root'
})
export class SidenavService {
  private _sidenavWidth: number = SideNavOpn;

  get sidenavWidth(): number {
    return this._sidenavWidth;
  }

  setSidenavWidth(width: number) {
    this._sidenavWidth = width;
  }
}